import { render } from "./AppHeader.vue?vue&type=template&id=dba326b0&scoped=true"
const script = {}

import "./AppHeader.vue?vue&type=style&index=0&id=dba326b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dba326b0"]])

export default __exports__